<script>
  import { Swiper } from 'cl-svelte-ui'
  import { onMount, onDestroy } from 'svelte'
  import { store } from '@store'
  import ArrowLeft from '@static/img/small_arrow_left.svg';
  import ArrowRight from '@static/img/small_arrow_right.svg'

  export let activeItem = 0,
  swiperElem,
  closeHandle,
  nextBtnClassName = '.gallery-button-next',
  prevBtnClassName = '.gallery-button-prev';

  export const prevArrowHandle = e => {}//swiperElem.api.slidePrev()

  export const nextArrowHandle = e => {}//swiperElem.api.slideNext()

  const galleryOptions = {
    slidesPerView: 'auto',
    initialSlide: activeItem,
    keyboard: {
      enabled: true,
      onlyInViewport: false
    },
    navigation: {
      nextEl: nextBtnClassName,
      prevEl: prevBtnClassName
    }
  }

  const escapeHandle = e => {
    if (e.keyCode === 27 || e.which === 27) {
      if (closeHandle) {
        closeHandle()
      }
    }
  }

  onMount(() => {
    window.addEventListener('keydown', escapeHandle, true)
    // setTimeout(() => {
    //   const galleryItems = document.querySelectorAll('.gallery-slide')
    //   for (let i=0; i < galleryItems.length; i++) {
    //     const item = galleryItems[i]
    //     const description = item.querySelector('.description-container')
    //     if (description) {
    //       const imgItem = item.querySelector('.gallery-img')
    //       const imgItemHeight = imgItem.getBoundingClientRect().height
    //       const diff = ((imgItemHeight - description.getBoundingClientRect().height)/imgItemHeight) * 100
    //       if (diff < 55) {
    //         description.style.transform = 'translateY(100%)'
    //       }
    //     }
    //   }
    // }, 300)

  })
  onDestroy(() => {
    if (!store.isServer) {
      window.removeEventListener('keydown', escapeHandle, true)
    }
  })
</script>


<div class="gallery-container position-relative" on:click={e => e.stopPropagation()}>
  <Swiper options={galleryOptions} bind:this={swiperElem}>
    <slot></slot>
  </Swiper>
  <button class="prev gallery-btn d-none d-md-block gallery-button-prev">
    {@html ArrowLeft}
  </button>
  <button class="next gallery-btn d-none d-md-block gallery-button-next">
    {@html ArrowRight}
  </button>
</div>

<style>
  .gallery-container {
    height: 100%;
    max-width: 60%;
    margin: auto;
    background: #1e1e1e;
    @media (max-width: 767px) {
      max-width: 100%;
    }
    :global(.swiper-wrapper) {
      display: flex;
      align-items: center;
    }

    :global(.swiper-button-disabled) {
      display: none;
    }
  }

  .gallery-btn {
    width: 130px;
    height: 100%;
    background: transparent;
    position: absolute;
    z-index: 1;
    top: 0;
    cursor: pointer;
    transition: background 0.3s;
    :global(*) {
      width: 25px;
      stroke-opacity: 0.3;
      stroke: white;
    }
    &:hover {
      :global(*) {
        stroke-opacity: 1;
      }
    }
  }

  .gallery-btn.prev {
    left: 0;
  }
  .gallery-btn.next {
    right: 0;
  }
</style>

